import {combineReducers} from 'redux';
import subscriptions from './subscriptions.reducer';

const subscriptionsReducer = combineReducers({
	subscriptions,
});

export default subscriptionsReducer;